import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import { MediaQuery as MQ } from '../media-query';
import { v4 as uuidv4 } from 'uuid';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = { width: window.innerWidth };
        this.uuid = uuidv4();
        props.getNotificationsMessages({
            uuid: this.uuid,
            placement: 'notification',
            tags: [],
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.width >= 900 && this.state.width < 900) {
            this.toggle();
            return true;
        }

        if (nextState.width < 900 && this.state.width >= 900) {
            return true;
        }

        if (nextProps.notifications[this.uuid] != this.props.notifications[this.uuid]) {
            if (
                this.props.notifications[this.uuid] != undefined
                &&
                nextProps.notifications[this.uuid].length > this.props.notifications[this.uuid].length
            ) {
                sessionStorage.removeItem('NCIconLI');
            }
            this.fetchNotifyDots(nextProps.notifications);

            return true;
        }

        if (nextProps.notify_dots != this.props.notify_dots) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            if (nextProps.logged_in) {
                sessionStorage.removeItem('NCLIState');
                sessionStorage.removeItem('NCIconLI');
            } else if (sessionStorage.getItem('NCIconLO') == 'viewed' && this.countUnreadMessages().length != 0) {
                sessionStorage.removeItem('NCIconLO');
            }
            this.closeNav();

            return true;
        }

        return false;
    }

    render({ notifications }) {
        if (notifications) {
            const unread = this.checkForIconDot();

            if (MQ.isMobile() || MQ.isTabletPortrait()) {
                return (
                    <notifications>
                        <notifications-icon onClick={this.toggle} ref={(el) => this.toggleIcon = el} unread={unread} />
                        {this.renderNotificationsList()}
                        <div className='overlay' onClick={(e) => this.click(e, 'Overlay')} />
                    </notifications>
                );
            }

            return (
                <notifications>
                    <notifications-icon unread={unread} />
                    {this.renderNotificationsList()}
                </notifications>
            );
        }

        return (<notifications />);
    }

    renderNotificationsList = () => {
        if (this.props.notifications && _.isArray(this.props.notifications[this.uuid])) {
            return (
                <notifications-list>
                    <p>Daily Insight Feed</p>
                    <button onClick={(e) => this.click(e, 'X')}>×</button>
                    {_.map(this.props.notifications[this.uuid], (notification) => this.renderItem(notification))}
                </notifications-list>
            );
        }

        return (
            <notifications-list>
                <p>Daily Insight Feed</p>
                <button onClick={(e) => this.click(e, 'X')}>×</button>
                <notifications-list-item unread={'0'}>
                    <a href='/daily-horoscope' className='has-text-tundora'>
                        No new notifications today. Check back tomorrow!
                        In the meantime, get insight with your&nbsp;
                        <span className='has-text-havelock-blue'>daily horoscope</span>.
                    </a>
                </notifications-list-item>
            </notifications-list>
        );
    }

    renderItem = (notification) => {
        let unread = this.props.logged_in ? 0 : 1;
        const sessionStateLO = sessionStorage.getItem('NCLOState');
        if ((this.props.logged_in && this.props.notify_dots) || (!this.props.logged_in && sessionStateLO)) {
            const dotsArray = this.props.logged_in ? this.props.notify_dots : JSON.parse(sessionStateLO);
            const matchingObject = _.findWhere(dotsArray, {code: notification.code.toLowerCase()});

            unread = matchingObject && matchingObject.viewed ? 0 : 1;
        }

        return (
            <notifications-list-item
                unread={unread}
                dangerouslySetInnerHTML={{__html: notification.message}}
                onClick={(e) => this.trackPromoClick(e, notification.code)}
            />
        );
    }

    toggle = (e) => {
        const isOpen = this.toggleIcon && this.toggleIcon.classList && this.toggleIcon.classList.contains('open');
        const misc_elements = document.querySelectorAll('body, top-bar, main, footer, notifications-list, div.overlay');

        if (window.innerWidth >= 900) {
            this.closeNotify();
        } else if (!isOpen) {
            this.closeNav();
            if (this.toggleIcon.classList) {
                this.toggleIcon.classList.add('open');
            }

            misc_elements.forEach((el) => el.classList && el.classList.add('show-notify'));
        } else {
            this.closeNotify();
        }

        if (e && e.target && e.target.localName == 'notifications-icon') {
            const action = `${this.props.logged_in ? 'LI' : 'LO'} ${isOpen ? 'Close' : 'Open'}`;
            this.props.trackEvent(['Notifications', action, 'Icon Mobile']);
        }
    }

    closeNotify = () => {
        const misc_elements = document.querySelectorAll('body, top-bar, main, footer, notifications-list, div.overlay');
        misc_elements.forEach((el) => el.classList && el.classList.remove('show-notify'));
        if (this.toggleIcon && this.toggleIcon.classList) {
            this.toggleIcon.classList.remove('open');
        }
    }

    closeNav = () => {
        document.querySelectorAll(
            'body, dfp[name="Top"], main, footer, top-bar, mobile-nav'
        ).forEach((el) => el.classList && el.classList.remove('show-nav'));

        const toggleMenu = document.querySelector('.toggle-menu');
        if (toggleMenu && toggleMenu.classList) {
            toggleMenu.classList.remove('open');
        }
    }

    click = (e, label) => {
        const action = `${this.props.logged_in ? 'LI' : 'LO'} Close`;
        this.props.trackEvent(['Notifications', action, label]);
        this.toggle(e);
    }

    trackPromoClick = (e, label) => {
        e.target.parentNode.setAttribute('unread', 0);
        const category = 'Notifications promo message';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);
        this.props.readNotification({ code: label });
    }

    checkForIconDot = () => {
        let unread = 0;
        if (!this.props.logged_in) {
            if (sessionStorage.getItem('NCLOState') == undefined) {
                unread = 1;
            } else if (sessionStorage.getItem('NCIconLO') != 'viewed' || this.checkTimestampExpired()) {
                unread = this.countUnreadMessages().length == 0 ? 0 : 1;
            }
        } else if (
            this.props.notify_dots
            &&
            (sessionStorage.getItem('NCIconLI') != 'viewed' || this.checkTimestampExpired())
        ) {
            unread = this.countUnreadMessages().length == 0 ? 0 : 1;
        }

        return unread;
    }

    checkTimestampExpired = () => {
        const timestampSession = sessionStorage.getItem('NCTimestamp');
        return timestampSession && Math.floor(Date.now() / 60000) > parseInt(timestampSession) ? true : false;
    }

    countUnreadMessages = () => {
        let unReadMessageCodes = [];
        const sessionLO = sessionStorage.getItem('NCLOState');
        if (this.props.logged_in && this.props.notify_dots) {
            _.values(this.props.notify_dots).map(obj => {
                if (obj.viewed == false) {
                    unReadMessageCodes.push(obj);
                }
            });
        } else if (!this.props.logged_in && sessionLO) {
            _.values(JSON.parse(sessionLO)).map(obj => {
                if (obj.viewed == false) {
                    unReadMessageCodes.push(obj);
                }
            });
        }

        return unReadMessageCodes;
    }

    fetchNotifyDots = (notifications) => {
        if (notifications && notifications[this.uuid]) {
            this.props.getNotificationsRead({ codes: notifications[this.uuid].map(obj => obj.code.toLowerCase()) });
        }
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

const mapStateToProps = (state) => ({
    notifications: state['promo-message'],
    logged_in: state.user && state.user.logged_in,
    member_uuid: state.user && state.user.member_uuid,
    notify_dots: state.notifications,
});

const mapDispatchToProps = (dispatch) => ({
    getNotificationsRead: (payload) => dispatch({ type: 'notifications:get', payload: payload }),
    getNotificationsMessages: (payload) => dispatch({ type: 'promo-message:require', payload: payload }),
    readNotification: (payload) => dispatch({ type: 'notifications:read', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);